import React, { useState, useEffect } from 'react';
import {
    fetchNodeTagCrawlSetting,
    fetchCrawlTools,
    modifyNodeTagCrawlSetting
 } from '../../../../api/inspiration';
import { Input, Select, message, Modal, Tooltip } from 'antd';

const { Option } = Select;

export default React.memo((props) => {
    const { superiorNode, isModifyUpdateModalVisible, setModifyUpdateModalVisible, setToolInfo, nodeInfo, toolInfo } = props;
    const [crawlToolId, setCrawlToolId] = useState(null);
    const [crawlTools, setCrawlTools] = useState([]);
    const [params, setParams] = useState([]);

    useEffect(() => {
        if (isModifyUpdateModalVisible) {
            setCrawlToolId((toolInfo?.crawlToolId || toolInfo?.crawlToolId == 0) && toolInfo.currentCrawlToolStatus == 1 ? toolInfo.crawlToolId : null);
            getCrawlTools();
        }
    }, [isModifyUpdateModalVisible]);

    useEffect(() => {
        if (superiorNode?.word) {
            getNodeTagCrawlSetting();
        }
    }, [superiorNode?.word]);

    const getNodeTagCrawlSetting = async () => {
        const res = await fetchNodeTagCrawlSetting(superiorNode?.word);
        if (res?.error?.code == 0 && res.data) {
            setToolInfo({...res.data});
        } else {
            setToolInfo(null);
        }
    }

    const getCrawlTools = async () => {
        const res = await fetchCrawlTools({
            pageSize: 500,
            page: 1
        });

        if (res?.error?.code == 0 && res.data?.crawlTools?.length > 0) {
            setCrawlTools(res.data.crawlTools);
            if (toolInfo && toolInfo.paramChange === false) {
                setParams(toolInfo?.crawlToolParams ?? []);
            } else {
                for (let tool of res.data.crawlTools) {
                    if (tool.id == toolInfo?.crawlToolId) {
                        setParams(JSON.parse(tool.crawlParam));
                        break;
                    }
                }
            }
        }
    };

    const onCrawlToolChange = value => {
        setCrawlToolId(value);
        if (toolInfo?.crawlToolId == value && toolInfo.paramChange === false) {
            setParams(toolInfo?.crawlToolParams ?? []);
        } else {
            for (let tool of crawlTools) {
                if (tool.id == value) {
                    setParams(JSON.parse(tool.crawlParam));
                    break;
                }
            }
        }
    };

    const onParamValueChange = (v, i) => {
        params[i].paramValue = v;
        setParams([...params]);
    };

    const handleOk = async () => {
        if (!crawlToolId) {
            message.error('请先选择爬取工具');
            return;
        }

        for (let item of params) {
            if (item.require == 1 && !item.paramValue?.trim('')) {
                message.error(`请填写所有必填参数的值`);
                return;
            }
        }

        let toolName = '';
        for (let tool of crawlTools) {
            if (tool.id == crawlToolId) {
                toolName = tool.crawlToolName;
                break;
            }
        }

        if (!toolName) {
            message.error('参数错误，请刷新页面后重试');
            return;
        }

        const res = await modifyNodeTagCrawlSetting({
            "crawlToolParams": params,
            "crawlToolId": crawlToolId,
            "crawlToolName": toolName,
            "nodeWord": nodeInfo.centerNodeTag?.word ?? ""
        });

        if (res?.error?.code == 0 && res.data) {
            message.success('保存成功');
            getNodeTagCrawlSetting();
            setModifyUpdateModalVisible(false);
        } else if (res?.error?.message) {
            message.error(res.error.message);
        } else {
            message.error('保存失败');
        }
    };

    const handleCancel = () => {
        setModifyUpdateModalVisible(false);
    };
   
    return (
        <Modal visible={isModifyUpdateModalVisible} onOk={handleOk} onCancel={handleCancel} okText='保存' cancelText='取消'>
            <div className='modify_updateNode_modal'>
                <h3>修改更新策略</h3>
                <div className='toolName'><span className='label'>节点名称：</span>{nodeInfo.centerNodeTag?.word ?? ""}</div>
                <div className='crawlTool_select_wrap'>
                    <span className='label'>爬取工具：</span>
                    <Select value={crawlToolId} className='crawlTool_select' onChange={onCrawlToolChange}>
                        {
                            crawlTools.map(v => v.crawlStatus == 1 &&<Option key={v.id} value={v.id}>{v.crawlToolName}</Option>)
                        }
                    </Select>
                </div>
                {
                    params.map((v, i) => (
                        <div className='keywords_wrap' key={i}>
                            <Tooltip title={v.paramDesc || ''}>
                                <span className='label' style={{cursor: 'pointer'}}>{v.paramDesc || ''}：</span>
                            </Tooltip>
                            <Input className='keywords_input' value={v.paramValue} placeholder={`请输入${v.paramTypeStr}`} onChange={e => onParamValueChange(e.target.value, i)} />
                            {
                                v.require == 1 && <span style={{color: 'red', marginLeft: '15px'}}>*</span>
                            }
                        </div>
                    ))
                }
            </div>
        </Modal>
    )
});